module.exports = __webpack_public_path__ + "static/media/submenu-centrocusto.6f21c887.svg";